export default "__VITE_ASSET__eU0kk9ns__"